const isArrayAttributeValueApplied = (attribute, currentRefinement) => {
    if (Array.isArray(attribute.value) && Array.isArray(currentRefinement)) {
        return (
            attribute.value.length === currentRefinement.length &&
            attribute.value.every(
                val =>
                    currentRefinement.includes(val) ||
                    currentRefinement.includes(`${val}`),
            )
        );
    }

    return false;
};

const isRangeAttribute = value =>
    Object.prototype.hasOwnProperty.call(value, 'min') ||
    Object.prototype.hasOwnProperty.call(value, 'max');

const isRangeAttributeValueApplied = (attribute, currentRefinement) =>
    (isRangeAttribute(attribute.value) &&
        isRangeAttribute(currentRefinement) &&
        (typeof attribute.value.min !== 'undefined' &&
            attribute.value.min === currentRefinement.min)) ||
    (typeof attribute.value.max !== 'undefined' &&
        attribute.value.max === currentRefinement.max);

const isPrimitiveAttributeValueApplied = (attribute, currentRefinement) =>
    (Array.isArray(currentRefinement) &&
        currentRefinement.length === 1 &&
        attribute.value === currentRefinement[0]) ||
    attribute.value === currentRefinement;

const isAttributeApplied = (attribute, currentRefinementItems) => {
    const { currentRefinement } =
        currentRefinementItems.find(item => item.attribute === attribute.key) ||
        {};

    if (!currentRefinement) {
        return false;
    }

    return (
        isArrayAttributeValueApplied(attribute, currentRefinement) ||
        isRangeAttributeValueApplied(attribute, currentRefinement) ||
        isPrimitiveAttributeValueApplied(attribute, currentRefinement)
    );
};

const isPastilleApplied = (pastille, currentRefinementItems) => {
    return pastille.attributes.every(attribute =>
        isAttributeApplied(attribute, currentRefinementItems),
    );
};

const isPromotedFiltersStepApplied = (step, currentRefinementItems) => {
    if (step.pastilles.length === 0) {
        return true;
    }

    if (currentRefinementItems.length === 0) {
        return false;
    }

    return step.pastilles.some(pastille =>
        isPastilleApplied(pastille, currentRefinementItems),
    );
};

export const getCurrentPromotedFiltersStep = (
    promotedFilters,
    currentRefinements,
    forcedStepIndex = -1,
) =>
    forcedStepIndex >= 0 && forcedStepIndex < promotedFilters.length
        ? promotedFilters[forcedStepIndex]
        : promotedFilters.find(
              promotedFiltersStep =>
                  !isPromotedFiltersStepApplied(
                      promotedFiltersStep,
                      currentRefinements,
                  ),
          );

export const getTabNames = (promotedFilters, currentRefinements) =>
    promotedFilters.map(step => {
        if (isPromotedFiltersStepApplied(step, currentRefinements)) {
            const pastilleApplied = step.pastilles.find(pastille =>
                isPastilleApplied(pastille, currentRefinements),
            );
            if (pastilleApplied) {
                return pastilleApplied.name;
            }
        }
        return step.name;
    });

export const getOtherPastilleAttributes = (
    promotedFilters = {},
    pastilleToExclude = {},
) =>
    promotedFilters.pastilles.reduce(
        (result, { id, attributes }) =>
            id !== pastilleToExclude.id ? [...result, ...attributes] : result,
        [],
    );

export const getAppliedPastilles = (promotedFilters, currentRefinements) =>
    promotedFilters.map(({ pastilles }) =>
        pastilles.find(pastille =>
            isPastilleApplied(pastille, currentRefinements),
        ),
    );

export const getStepIndexByPastille = (promotedFilters, pastille) =>
    promotedFilters.findIndex(step =>
        step.pastilles.find(({ id }) => id === pastille.id),
    );
